import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  hubspotPipedreamService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface HubSpotPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function HubSpotPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: HubSpotPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="hubspot"
      displayName="HubSpot"
      description="Connect your HubSpot account so your assistant can read and update CRM records during conversations."
      features={[
        'Search contacts, companies, deals, and tickets',
        'Read engagement history (notes, emails, calls)',
        'Create and update CRM records on your behalf',
        'Log notes and activity against the right record',
      ]}
      accentColor="orange"
      events={{
        modalOpened: OnboardingEvents.HUBSPOT_MODAL_OPENED,
        oauthStarted: OnboardingEvents.HUBSPOT_OAUTH_STARTED,
        connected: OnboardingEvents.HUBSPOT_CONNECTED,
        connectionFailed: OnboardingEvents.HUBSPOT_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.HUBSPOT_MODAL_CLOSED,
      }}
      // NEW connections go through Pipedream Connect. Status/disconnect are
      // shared with the native self-hosted-OAuth service, so existing native
      // connections keep working unchanged.
      service={hubspotPipedreamService}
    />
  );
}
